import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingAnchorReview: true,
  currSubmitModuleReviewId:null,
  modulNeedReview:0
}

export const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    setLoadingAnchorReview: (state, action) => {
      state.loadingAnchorReview = action.payload;
    },
    setRefetchAnchorReview: (state, action) => {
      state.currSubmitModuleReviewId = action.payload;
    },
    setModuleNeedReview: (state, action) => {
      state.modulNeedReview = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setLoadingAnchorReview, setRefetchAnchorReview, setModuleNeedReview } = reviewSlice.actions

export default reviewSlice.reducer